import React from 'react';
export function ContactForm({
  id = 'contact-form'
}: {
  id?: string;
}) {
  return <div id={id} style={{
    width: '100%',
    border: 'none',
    display: 'block'
  }} data-id="element-35">
      <iframe id="JotFormIFrame-260674488073062" title="Book Your Free Strategy Call" src="https://form.jotform.com/260674488073062" allow="geolocation; microphone; camera; fullscreen; payment" style={{
      width: '100%',
      height: '800px',
      border: 'none',
      display: 'block'
    }} scrolling="no" data-id="element-36" />
    </div>;
}